// static class Queue with async functions, to be used with async/await
// it will schedule tasks in order, and will run them,
// it will offer option to run tasks in parallel, but will wait for all tasks to finish before running the next one

import { logger } from "@services/workers/helpers";

const nameSpace = "Queue";

export class Queue {
  public queue: Promise<any>[] = [];

  public push(task: Promise<any>) {
    this.queue.push(task);
  }

  // push multiple tasks at once
  public pushMany(tasks: Promise<any>[]) {
    tasks.forEach((task) => {
      this.queue.push(task);
    });
  }

  public async run() {
    // await for loop to finish
    // run tasks in order
    for (const task of this.queue) {
      logger.debug(nameSpace + "->" + this.run.name, "Running task...", task);
      const result = await task;
      logger.debug(nameSpace + "->" + this.run.name, "Task finished!", result);
    }
  }

  public async runParallel() {
    logger.debug(nameSpace + "->" + this.runParallel.name, "Running tasks in parallel...", this.queue);
    const results = await Promise.all(this.queue);
    this.queue = [];
    logger.debug(nameSpace + "->" + this.runParallel.name, "Tasks finished!", results);
  }
}

export default Queue;
